import { Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function CheckInboxPanel({ email, onBack }) {
  return (
    <div className="space-y-6 text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-primary/30 bg-primary/10">
        <Mail className="h-7 w-7 text-primary" />
      </div>
      <div className="space-y-2">
        <h3 className="text-2xl font-bold text-foreground">Confirmation sent</h3>
        <p className="text-muted-foreground">
          We sent a confirmation link {email ? (
            <>
              to <span className="font-semibold text-foreground">{email}</span>
            </>
          ) : (
            'to your email address'
          )}. Click it to activate your operator profile.
        </p>
      </div>
      <Button
        type="button"
        variant="ghost"
        onClick={onBack}
        className="h-11 rounded-xl text-sm font-semibold"
      >
        Back to sign in
      </Button>
    </div>
  )
}
